import { render, staticRenderFns } from "./bdmCommissionGenerate.vue?vue&type=template&id=05c4b71e&"
import script from "./bdmCommissionGenerate.vue?vue&type=script&lang=js&"
export * from "./bdmCommissionGenerate.vue?vue&type=script&lang=js&"
import style0 from "./bdmCommissionGenerate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports